<template>
  <div class="mt-3 mb-3" v-if="response && response.numFound && timelineFilter">
    <label class="facetlabel">{{$t('scifund.labels.'+this.facetname)}}</label>

    <TimelineFilter @change="triggerFilter" :ref="this.facetname" :list="timelineFilter" class="timeline">

      <template #slider="scoped">
<!--
        <el-slider @change="changeSlider" style="margin-top:-15px"
        v-model="scoped.value" range :max="scoped.data.length-1"
        :format-tooltip="formatTooltip" >
        </el-slider>
-->

        <vue-slider
          v-model="scoped.value"
          :min="0"
          :max="scoped.data.length-1"
          :tooltip="'always'"
          :enable-cross="false"
          :lazy="true"
          :tooltipPlacement="['bottom', 'bottom']"
          @change="changeSlider"
          class="mb-5 timeline-slider"
          style="margin-top:-5px;"
          :silent="true"
          :tooltipFormatter="formatTooltip"
          :dotOptions="dotOptions"
          stepActiveStyle="backgroundColor:#ff0000"

        ></vue-slider>

      </template>

    </TimelineFilter>

<!--
    <HistogramSlider
    ref="hist"
    :width="900"
    :bar-height="100"
    :data="dateFilter"
    :prettify="prettify"
    :drag-interval="true"
    :min="new Date('01 Jan 2010 00:00:00 GMT').valueOf()"
    :max="new Date('31 Dec 2025 00:00:00 GMT').valueOf()"
    :from="start"
    :to="end"
    @finish="dateFilterChanged"
    />
-->
  </div>
</template>

<script>
/*
import Vue from 'vue';

import HistogramSlider from 'vue-histogram-slider';
import 'vue-histogram-slider/dist/histogram-slider.css';


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
*/
import TimelineFilter from 'vue-timeline-filter-component';


export default {
  name: 'DateHistogramSlider',
  props: [ 'facetname' ],
  components: {
    TimelineFilter,
    //HistogramSlider
  },
  data () {
    return {
      dotOptions: [{
          style: {
            "backgroundColor": "#1eb194",
            "border": "1px solid #fff",
          },
          tooltipStyle : {
            "backgroundColor": "#1eb194",
          },
        },
        {
          style: {
            "backgroundColor": "#1eb194",
            "border": "1px solid #fff",
          },
          tooltipStyle : {
            "backgroundColor": "#1eb194",
          },
        }],
      railStyle: {
        "backgroundColor": "#1eb194",
      },
      prettify: function(ts) {
        return new Date(ts).toLocaleDateString("en", {
          year: "numeric",
          month: "short",
          day: "numeric"
        });
      }
    }
  },
  methods: {
    changeSlider(val){
        this.$refs[this.facetname].value = val;

        var starttimestr = '' + this.timelineFilter[val[0]]["label"] + ' 00:00:00 GMT+0000';
        var endtimestr = '' + this.timelineFilter[val[1]]["label"] + ' 00:00:00 GMT+0000';
        var endDate = new Date(endtimestr);
        endDate.setUTCMonth(endDate.getUTCMonth()+1);

        var action = this.actionurl;
        action = decodeURIComponent(decodeURIComponent(action));
        action = action.replace('${start}', new Date(starttimestr).toISOString());
        action = action.replace('${end}', endDate.toISOString());
        this.$router.push(action);
      },
    triggerFilter(val){
      var starttimestr = '' + val[0]["label"] + ' 00:00:00 GMT+0000';
      var endtimestr = '' + val[1]["label"] + ' 00:00:00 GMT+0000';
      var endDate = new Date(endtimestr);
      endDate.setUTCMonth(endDate.getUTCMonth()+1);

      var action = this.actionurl;
      action = decodeURIComponent(decodeURIComponent(action));
      action = action.replace('${start}', new Date(starttimestr).toISOString());
      action = action.replace('${end}', endDate.toISOString());
      this.$router.push(action);

    },
    formatTooltip(val){
      if( val != null && this.timelineFilter && this.timelineFilter[val] ) {
        return this.timelineFilter[val].label;
      } else {
        return "";
      }
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    actionurl() {
      if (this.$store.state.response &&
        this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_ranges &&
            this.$store.state.response.facet_counts.facet_ranges[this.facetname]){
        return this.$store.state.response.facet_counts.facet_ranges.[this.facetname].sem_action.sem_url_action;
      }
      return null;
    },
    timelineFilter () {
      if (this.$store.state.response &&
        this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_ranges &&
            this.$store.state.response.facet_counts.facet_ranges[this.facetname]) {
              var dateArray = [];
              var activeDateArray = [];
              for(var d in this.$store.state.response.facet_counts.facet_ranges[this.facetname].counts) {
                var dd = this.$store.state.response.facet_counts.facet_ranges[this.facetname].counts[d];
                var date = new Date(dd.value);
                if(this.isValidDate(date)) {
                  dateArray.push({'label': date.toLocaleDateString("en", {
                    year: "numeric",
                    month: "short",
                    day: "numeric"
                  }), 'value': dd.count})
                }

               if( dd.active && dd.active == true ) {
                 activeDateArray.push({'label': new Date(dd.value).toLocaleDateString("en", {
                   year: "numeric",
                   month: "short",
                   day: "numeric"
                 }), 'value': dd.count})
               }


              }

              if( activeDateArray.length > 0 ) {
                return activeDateArray;
              } else {
                return dateArray;
              }


      }
      return null;
    }
  }
}
</script>

<style scoped>
  .timeline {
    margin-left: 8%;
    width:84%;

  }
  .facetlabel {
    font-size: 14px;
    color: #888;
    font-weight: 700;
  }

</style>
